import { ErrorHandler, Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private auth: AuthService) {}
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
   
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}